module.exports = __webpack_public_path__ + "static/img/szafa_15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_15.svg
// module id = ZpeZ
// module chunks = 0